import React from 'react';

type ValueButtonProps = {
  value?: number;
  onClick?: () => void;
};

const ValueButton = ({ value, onClick }: ValueButtonProps) => {
  const formattedValue = value
    ? new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(value)
    : 'R$ 0,00';
  return (
    <button className="value-button" onClick={onClick}>
      <span>{formattedValue}</span>
    </button>
  );
};

export default ValueButton;
